
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormTextInput from './FormTextInput'
import FormPhoneNumber from './FormPhoneNumber'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormInvoiceRecipients = ({
  colSize,
  inputLabel,
  className,
  countryOptions,
  recipients,
  handleAddRecipients,
  handlePhoneCountry,
  errors,
  handleChange,
  handleRemoveRecipients,
  isDetail
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !isDetail && (
            <CButton
              onClick={() => handleAddRecipients()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {recipients?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {recipients?.length > 0 ? (
        recipients?.map((inputField, index) => {
          return (
            <CAccordion activeItemKey={isDetail ? 0 : index+1}>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Recipient {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className="mb-4">
                    <FormTextInput 
                      id='recipient_name'
                      name='recipient_name'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Name'
                      placeholder='Enter recipient name...'
                      value={inputField?.recipient_name}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.recipients?.length > 0 && errors?.recipients[index]?.recipient_name}
                      invalid={errors?.recipients?.length > 0 && errors?.recipients[index]?.recipient_name}
                      disabled={isDetail}
                    />
                    <FormTextInput 
                      id='recipient_email'
                      name='recipient_email'
                      colSize='6'
                      inputLabel='Email Address'
                      className='mb-3'
                      placeholder='Enter recipient email address...'
                      value={inputField?.recipient_email}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.recipients?.length > 0 && errors?.recipients[index]?.recipient_email}
                      invalid={errors?.recipients?.length > 0 && errors?.recipients[index]?.recipient_email}
                      handleClickButton={handleAddRecipients}
                      disabled={isDetail}
                    />
                    <FormPhoneNumber
                      id='recipient_contact_number'
                      name='recipient_contact_number'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Phone Number'
                      placeholder='Enter recipient phone number...'
                      countryOptions={countryOptions}
                      country={inputField?.country_value}
                      value={inputField}
                      handlePhoneNumber={(e) => handleChange(e, index)}
                      handlePhoneCountry={(e) => handlePhoneCountry(e, index)}
                      errors={errors?.recipients?.length > 0 && errors?.recipients[index]}
                      disabled={isDetail}
                      colSizeSelectCode='3'
                    />
                  </CRow>
                  <CRow>
                    <CCol lg={1}>
                      {
                        recipients?.length > 0 && !isDetail && (
                          <CButton
                            style={styleButtonVars2}
                            onClick={() => {handleRemoveRecipients(inputField, index)}}
                          >
                            Delete
                          </CButton>
                        )
                      }
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>

          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add invoice recipients</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have invoice recipients</b></div>
      )}
    </CCol>
  )
}

export default FormInvoiceRecipients
